/* eslint-disable react/jsx-no-target-blank */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../../lib/PropTypes';
import { getComponentFromName } from '../../../lib/utils';

import { useLabels } from '../../../contexts/LabelsContext';
import { useTheme } from '../../../contexts/ThemeContext';
import BiteSize from '../../icons/logos/BiteSize';
import * as LogoComponents from '../../icons/logos/index';
import Menu from '../../menus/Menu';

import styles from '../../../../styles/partials/footer-nhl.module.scss';

// import hockeyNightPartners from '../../../../img/nhl/hockey-night-partners.svg';

const propTypes = {
    className: PropTypes.string,
    menuClassName: PropTypes.string,
    menuItemsClassName: PropTypes.string,
    menuItems: AppPropTypes.menuItems,
    onMenuItemClick: PropTypes.func,
    withoutLegal: PropTypes.bool,
};

const defaultProps = {
    className: null,
    menuClassName: null,
    menuItemsClassName: null,
    menuItems: null,
    onMenuItemClick: null,
    withoutLegal: false,
};

function FooterNHL({
    className,
    menuClassName,
    menuItemsClassName,
    menuItems,
    onMenuItemClick,
    withoutLegal,
}) {
    const { footer = null } = useTheme();
    const { footerLegal: legal = null } = useLabels();
    const { poweredBy = false, beerPartnersLogo = null } = footer || {};
    const LogoComponent = getComponentFromName(
        LogoComponents,
        beerPartnersLogo,
        'nhl-molson-canadian',
    );
    return (
        <footer className={classNames([styles.container, { [className]: className !== null }])}>
            {legal !== null && !withoutLegal ? (
                <div className={styles.legal} dangerouslySetInnerHTML={{ __html: legal }} />
            ) : null}
            <div className={styles.bar}>
                <div className={styles.content}>
                    <div className={styles.beerPartners}>
                        <LogoComponent className={styles.logo} />
                    </div>
                    {poweredBy ? (
                        <a
                            href="https://bitesizeinc.com"
                            target="_blank"
                            className={styles.poweredBy}
                        >
                            <span className={styles.label}>
                                <FormattedMessage
                                    defaultMessage="Powered by"
                                    description="Logo texte"
                                />
                            </span>
                            <BiteSize className={styles.logo} />
                        </a>
                    ) : null}
                </div>
                {(menuItems || []).length > 0 ? (
                    <Menu
                        className={classNames([
                            styles.menu,
                            { [menuClassName]: menuClassName !== null },
                        ])}
                        items={menuItems}
                        itemsClassName={menuItemsClassName}
                        onItemClick={onMenuItemClick}
                    />
                ) : null}
            </div>
        </footer>
    );
}

FooterNHL.propTypes = propTypes;
FooterNHL.defaultProps = defaultProps;

export default FooterNHL;
